module.exports = {
getGenderByCode(gender) {
    let result;
    switch (gender) {
      case 18:
        result = "Male";
        break;
      case 19:
        result = "Female";
        break;
      case 3391:
        result = "Non-Binary";
        break;
      case 3392:
        result = "Different Identity";
        break;
      case 3393:
        result = "Prefer Not To Say";
        break;
      default:
        result = "Other";
        break;
    }
    return result;
  },
  getGenderByString(gender) {
    let result 
    switch (gender) {
      case "Male":
        result = 18;
        break;
      case "Female":
        result = 19;
        break;
      case "Non-Binary":
        result = 3391;
        break;
      case "Different Identity":
        result = 3392;
        break;
      case "Prefer Not to Say":
        result = 3393;
        break;
      default: 
        result = 20;
        break;
    }
    return result;
  },
}